import { useQuery } from "@tanstack/react-query";
import { getIndustries } from "@api/v1/methods";
import { GET_INDUSTRIES_KEY } from "../../cacheKeys";

export const useIndustries = () =>
  useQuery({
    queryKey: [GET_INDUSTRIES_KEY],
    queryFn: () => getIndustries(),
    staleTime: Infinity,
  });
